/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Mobile Footer Collapsible - Direct Implementation
  const footer = document.querySelector('.site-footer-wrapper');
  if (footer) {
    function isMobile() {
      return window.innerWidth <= 749;
    }

    let mobileFooterActive = false;

    function initMobileFooter() {
      if (!isMobile() || mobileFooterActive) return;

      console.log('Initializing mobile footer collapsible');
      mobileFooterActive = true;

      const footerBlocks = footer.querySelectorAll('.footer__block[data-collapsible]:not(.footer__block--newsletter)');
      
      footerBlocks.forEach((block, index) => {
        const trigger = block.querySelector('[data-collapsible-trigger]');
        const body = block.querySelector('[data-collapsible-body]');
        
        if (!trigger || !body) return;

        console.log('Setting up mobile footer block:', index);

        block.classList.add('footer__block--mobile-collapsible');
        trigger.classList.add('footer__title--mobile-clickable');

        block.setAttribute('data-collapsible', 'disabled');
        
        const existingIcon = trigger.querySelector('svg, .icon');
        if (existingIcon) {
          existingIcon.remove();
        }

        if (!trigger.querySelector('.footer__toggle-icon')) {
          const toggleIcon = document.createElement('span');
          toggleIcon.className = 'footer__toggle-icon';
          toggleIcon.textContent = '+';
          trigger.appendChild(toggleIcon);
        }

        body.style.height = '0px';
        body.style.overflow = 'hidden';
        body.style.transition = 'height 0.3s ease';
        
        let isExpanded = false;
        block.removeAttribute('open');

        const newTrigger = trigger.cloneNode(true);
        trigger.parentNode.replaceChild(newTrigger, trigger);

        newTrigger.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          
          const toggleIcon = newTrigger.querySelector('.footer__toggle-icon');
          const currentBody = block.querySelector('[data-collapsible-body]');
          const content = currentBody.querySelector('[data-collapsible-content]');
          
          console.log('Mobile footer clicked, current state:', isExpanded);

          if (isExpanded) {
            currentBody.style.height = '0px';
            toggleIcon.textContent = '+';
            isExpanded = false;
            block.removeAttribute('open');
            console.log('Collapsing');
          } else {
            const contentHeight = content ? content.scrollHeight : currentBody.scrollHeight;
            currentBody.style.height = contentHeight + 'px';
            toggleIcon.textContent = '−';
            isExpanded = true;
            block.setAttribute('open', 'true');
            console.log('Expanding to height:', contentHeight);
          }
        });

        block._mobileExpanded = isExpanded;
        block._mobileHandler = newTrigger;
      });
    }

    function resetMobileFooter() {
      if (!mobileFooterActive) return;

      console.log('Resetting mobile footer');
      mobileFooterActive = false;

      const footerBlocks = footer.querySelectorAll('.footer__block--mobile-collapsible');
      
      footerBlocks.forEach((block) => {
        const trigger = block.querySelector('[data-collapsible-trigger]');
        const body = block.querySelector('[data-collapsible-body]');
        
        block.classList.remove('footer__block--mobile-collapsible');
        if (trigger) {
          trigger.classList.remove('footer__title--mobile-clickable');
        }

        block.setAttribute('data-collapsible', '');
        
        const toggleIcon = trigger?.querySelector('.footer__toggle-icon');
        if (toggleIcon) {
          toggleIcon.remove();
        }

        if (body) {
          body.style.height = '';
          body.style.overflow = '';
          body.style.transition = '';
        }

        delete block._mobileExpanded;
        delete block._mobileHandler;

        block.removeAttribute('open');
      });

      setTimeout(() => {
        const collapsibleContainer = footer.querySelector('collapsible-elements');
        if (collapsibleContainer && typeof collapsibleContainer.toggle === 'function') {
          collapsibleContainer.toggle();
        }
      }, 50);
    }

    initMobileFooter();

    let resizeTimeout;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(() => {
        if (isMobile()) {
          initMobileFooter();
        } else {
          resetMobileFooter();
        }
      }, 150);
    });
  }

  // Wine Club App - Go Back Button Scroll to Top
  // This handles the "Go back" button in the subscription module
  // to scroll back to the top of the subscription section
  function initWineClubGoBackButton() {
    const subscriptionModule = document.querySelector('.subscription-module');
    if (!subscriptionModule) return;

    // Function to scroll to top of subscription module
    function scrollToSubscriptionTop() {
      // Wait for DOM updates to complete
      setTimeout(() => {
        const targetModule = document.querySelector('.subscription-module');
        if (targetModule) {
          // Get the header height to offset the scroll position
          const header = document.querySelector('.site-header, header, .shopify-section-header');
          const headerHeight = header ? header.offsetHeight : 0;
          
          // Get absolute position of the element
          const rect = targetModule.getBoundingClientRect();
          const absoluteTop = rect.top + window.scrollY;
          
          // Scroll to top of subscription module
          window.scrollTo({
            top: Math.max(0, absoluteTop - headerHeight - 20),
            behavior: 'smooth'
          });
        }
      }, 150);
    }

    // Use MutationObserver to watch for the "Go back" button being added dynamically
    const observer = new MutationObserver((mutations, obs) => {
      // Look for all secondary buttons and "Add to cart" primary buttons
      const allButtons = subscriptionModule.querySelectorAll('.wh-button-secondary, .wh-button-primary, button');
      
      allButtons.forEach((button) => {
        // Check if it's the "Go back" button or "Add to cart" button
        const buttonText = button.textContent.toLowerCase();
        const isGoBackButton = buttonText.includes('go back');
        const isAddToCartButton = buttonText.includes('add to cart');
        
        if ((isGoBackButton || isAddToCartButton) && !button.hasAttribute('data-scroll-handler-added')) {
          button.setAttribute('data-scroll-handler-added', 'true');
          
          button.addEventListener('click', scrollToSubscriptionTop);
        }
      });
    });

    // Start observing the subscription module for changes
    observer.observe(subscriptionModule, {
      childList: true,
      subtree: true
    });

    // Also try to attach to any existing buttons immediately
    const existingButtons = subscriptionModule.querySelectorAll('.wh-button-secondary, .wh-button-primary, button');
    existingButtons.forEach((button) => {
      const buttonText = button.textContent.toLowerCase();
      const isGoBackButton = buttonText.includes('go back');
      const isAddToCartButton = buttonText.includes('add to cart');
      
      if ((isGoBackButton || isAddToCartButton) && !button.hasAttribute('data-scroll-handler-added')) {
        button.setAttribute('data-scroll-handler-added', 'true');
        button.addEventListener('click', scrollToSubscriptionTop);
      }
    });
    
    console.log('Wine Club scroll handler initialized');
  }

  // Wait for the subscription module to load (it's dynamically loaded by the app)
  function waitForSubscriptionModule() {
    let attempts = 0;
    const maxAttempts = 60; // 30 seconds at 500ms intervals
    
    const checkInterval = setInterval(() => {
      attempts++;
      const subscriptionModule = document.querySelector('.subscription-module');
      
      if (subscriptionModule) {
        clearInterval(checkInterval);
        console.log('Subscription module found, initializing scroll handler');
        initWineClubGoBackButton();
      } else if (attempts >= maxAttempts) {
        clearInterval(checkInterval);
        console.log('Subscription module not found after 30 seconds');
      }
    }, 500);
  }

  // Initialize when DOM is ready or immediately if already loaded
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', waitForSubscriptionModule);
  } else {
    waitForSubscriptionModule();
  }

  // ============================================================
  // Collection Filter Exclusion Logic
  // Special Offers and Customer Exclusives should ONLY appear 
  // in their dedicated collections, not on other collection pages
  // ============================================================
  
  function initCollectionFilterExclusion() {
    // Only run on collection pages
    if (!window.location.pathname.includes('/collections/')) return;
    
    // Define exclusive categories (Product Types that should be isolated)
    const exclusiveCategories = ['special-offers', 'customer-exclusives', 'special offers', 'customer exclusives'];
    
    // Check if we're on a dedicated exclusive collection page
    const collectionHandle = window.location.pathname.split('/collections/')[1]?.split(/[/?#]/)[0]?.toLowerCase() || '';
    const isExclusiveCollectionPage = exclusiveCategories.some(cat => 
      collectionHandle === cat || collectionHandle === cat.replace(/\s+/g, '-')
    );
    
    function applyFilterExclusion() {
      // --- Hide exclusive products from the grid (only on non-exclusive pages) ---
      if (!isExclusiveCollectionPage) {
        const productGrid = document.querySelector('[data-products-grid]');
        
        if (productGrid) {
          const productItems = productGrid.querySelectorAll('[data-grid-item]');
          
          productItems.forEach(item => {
            const productType = (item.getAttribute('data-product-type') || '').toLowerCase();
            
            if (exclusiveCategories.includes(productType)) {
              item.style.display = 'none';
            }
          });
        }
      }
      
      // --- Always hide exclusive filter options from the sidebar on ALL pages ---
      hideExclusiveFilterOptions();
    }
    
    function hideExclusiveFilterOptions() {
      const sidebar = document.querySelector('[data-collection-sidebar]');
      if (!sidebar) return;
      
      // Find all filter checkbox items in the sidebar
      const filterItems = sidebar.querySelectorAll('li.sidebar__item');
      
      filterItems.forEach(item => {
        const checkbox = item.querySelector('input[type="checkbox"]');
        const label = item.querySelector('label span');
        
        if (!checkbox && !label) return;
        
        // Match by checkbox value or label text
        const filterValue = (checkbox?.value || '').toLowerCase();
        const labelText = (label?.textContent || '').trim().toLowerCase();
        
        const isExclusive = exclusiveCategories.includes(filterValue) || 
                            exclusiveCategories.includes(labelText);
        
        if (isExclusive) {
          item.style.display = 'none';
        }
      });
      
      // Hide entire filter groups if all their items are now hidden
      const filterGroups = sidebar.querySelectorAll('.filter-group');
      filterGroups.forEach(group => {
        const visibleItems = group.querySelectorAll('li.sidebar__item:not([style*="display: none"])');
        if (group.querySelectorAll('li.sidebar__item').length > 0 && visibleItems.length === 0) {
          group.style.display = 'none';
        }
      });
    }
    
    function revealSidebar() {
      const sidebar = document.querySelector('.collection__sidebar');
      if (sidebar) {
        sidebar.classList.add('filters-ready');
      }
    }
    
    // Apply on initial load then reveal
    applyFilterExclusion();
    revealSidebar();
    
    // Re-apply when URL changes (filter updates via back/forward)
    window.addEventListener('popstate', () => {
      applyFilterExclusion();
      revealSidebar();
    });
    
    // Observe for AJAX content updates (when filters change)
    const productsContainer = document.querySelector('[data-products-grid]');
    if (productsContainer) {
      const observer = new MutationObserver(() => {
        applyFilterExclusion();
      });
      
      observer.observe(productsContainer, {
        childList: true,
        subtree: true
      });
    }
    
    // Also observe sidebar for re-renders (AJAX filter updates replace sidebar HTML)
    const sidebarContainer = document.querySelector('[data-collection-sidebar]');
    if (sidebarContainer) {
      const sidebarObserver = new MutationObserver(() => {
        hideExclusiveFilterOptions();
        revealSidebar();
      });
      
      sidebarObserver.observe(sidebarContainer, {
        childList: true,
        subtree: true
      });
    }
    
    // Also listen for URL changes that don't trigger popstate
    let lastUrl = window.location.href;
    setInterval(() => {
      if (window.location.href !== lastUrl) {
        lastUrl = window.location.href;
        applyFilterExclusion();
      }
    }, 300);
    
    console.log('Collection filter exclusion initialized');
  }
  
  // Initialize filter exclusion
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCollectionFilterExclusion);
  } else {
    initCollectionFilterExclusion();
  }

  // ============================================================
  // Sidebar Navigation - Default Collection Redirect
  // When unchecking a sidebar nav link, redirect to the default
  // collection URL configured in the section settings
  // ============================================================
  
  function initSidebarNavRedirect() {
    const sidebar = document.querySelector('[data-collection-sidebar]');
    if (!sidebar) return;
    
    const defaultUrl = sidebar.getAttribute('data-default-collection-url');
    if (!defaultUrl) return;
    
    function attachLinkHandlers() {
      // Target only the linklist sidebar nav links (not filter checkboxes)
      const navLinks = sidebar.querySelectorAll('.collection-nav li.sidebar__item a');
      
      navLinks.forEach(link => {
        if (link.hasAttribute('data-default-redirect-bound')) return;
        link.setAttribute('data-default-redirect-bound', 'true');
        
        link.addEventListener('click', function(e) {
          const listItem = link.closest('li.sidebar__item');
          
          // If this is the active/checked item being unchecked, go to default URL
          if (listItem && listItem.classList.contains('sidebar__item--active')) {
            e.preventDefault();
            window.location.href = defaultUrl;
          }
        });
      });
    }
    
    // Attach on load
    attachLinkHandlers();
    
    // Re-attach after AJAX sidebar re-renders
    const observer = new MutationObserver(() => {
      attachLinkHandlers();
    });
    
    observer.observe(sidebar, {
      childList: true,
      subtree: true
    });
    
    console.log('Sidebar nav default redirect initialized:', defaultUrl);
  }
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSidebarNavRedirect);
  } else {
    initSidebarNavRedirect();
  }

  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
